import { Component, OnInit } from '@angular/core';
import { LandingService } from '../landing.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SiteBusinessDaysStatusEnum } from 'app/core/enums/generated/SiteBusinessDaysStatusEnum';

import { BusinessDaysWidgetVm } from 'app/shared/generated/Dashboard/Models/BusinessDaysWidgetVm'

@Component({
    selector: 'pcg-business-days',
    templateUrl: './business-days.component.html',
    styleUrls: ['./business-days.component.scss'],
    standalone: false
})
export class BusinessDaysComponent implements OnInit {

    formGroup = BusinessDaysWidgetVm.Form;
    model = BusinessDaysWidgetVm.GetModel(this.formGroup);
    model$: Observable<BusinessDaysWidgetVm>;
    businessDayStatusEnum = SiteBusinessDaysStatusEnum;

    constructor(private landingService: LandingService) {}

    ngOnInit(): void {
        this.model$ = this.landingService.getDashboardBusinessDays().pipe(
            tap((model: BusinessDaysWidgetVm) => {
                this.formGroup.setValue(model);
            }));
        }
    }
